import React from 'react'

import { useTranslation } from 'react-i18next'
import { DataItem } from 'scrivito'

import { SearchError } from './SearchError'
import { SearchNoResults } from './SearchNoResults'
import { SearchResultLoading } from './SearchResultLoading'
import { SearchResultsCardFooter } from './SearchResultsCardFooter'
import { SearchResultsItem } from './SearchResultsItem'

interface SearchResultsCardProps {
  searchResults: DataItem[]
  hideSearchResults: () => void
  showAllResults: () => void
  loading: boolean
  error: string
}

export const SearchResultsCard: React.FC<SearchResultsCardProps> = ({
  searchResults,
  hideSearchResults,
  showAllResults,
  loading,
  error,
}) => {
  const { t } = useTranslation()

  if (error) return <SearchError />

  if (!loading && searchResults.length === 0) return <SearchNoResults />

  return (
    <div className="card dxp-search-results-card">
      <div className="card-body">
        <h6 className="m-0">{t('search.searchResults')}</h6>
      </div>
      <div className="jr-list-flex obj-list">
        {loading ? (
          <>
            <SearchResultLoading />
            <SearchResultLoading />
            <SearchResultLoading />
          </>
        ) : (
          searchResults.map((searchResult) => (
            <SearchResultsItem
              key={searchResult.id()}
              searchResult={searchResult}
              hideSearchResults={hideSearchResults}
            />
          ))
        )}
      </div>
      <SearchResultsCardFooter showAllResults={showAllResults} />
    </div>
  )
}
